import styled, { keyframes } from "styled-components";

export const shine = keyframes`
0% {
  left: -40%;
}
100% {
  left: 100%;
}
`;

export const Container = styled.div<{ visible: boolean }>`
  width: 100%;
  height: ${({ visible }) => (visible ? "10px" : "0px")};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  background-color: #eee;
  border-radius: 8px;
  overflow: hidden;
  transition:
    opacity 0.5s ease,
    height 0.5s ease;
`;

export const Filler = styled.div<{ width: number; animateToFull: boolean }>`
  position: relative;
  height: 100%;
  background-color: var(--red);
  width: ${({ width }) => width}%;
  transition: ${({ animateToFull }) => (animateToFull ? "width 0.8s ease" : "none")};
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: -40%;
    width: 40%;
    height: 100%;
    background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.4), transparent);
    animation: ${shine} 2s infinite;
  }
`;
